export default "__VITE_ASSET__CNgEKveV__"